export const ALERT_DURATION = 4000;
